<template src="./Bubble.html"></template>
<style src="./Bubble.scss" lang="scss"></style>

<script>
  import Icon from '@/components/Icon/Icon'

  export default {
    name: 'HpBubble',
    components: {
      'hp-icon': Icon
    },
    props: {
      href: String,
      imageUrl: String,
      iconUrl: String,
      text: String,
      textColor: String,
      backgroundColor: String
    },
    data () {
      return {
        isVisible: true
      }
    },
    computed: {
      style () {
        let inlineStyle = this.textColor ? `color:${this.textColor};` : ''
        inlineStyle += this.backgroundColor ? `background:${this.backgroundColor};` : ''

        return inlineStyle || false
      }
    },
    methods: {
      close () {
        this.isVisible = false
      }
    }
  }
</script>
